import { api } from "../api";

export function getTrancheAge() {
    return api.get("TrancheAge/getasync");
}